<div class="row">
    <div class="col-md-6 col-12">
        <abi-form-field label="Job Status" cols="col-12">
            <input abiLookup="CodeJobStatus" abiTypeahead noBootstrap [ngModel]="jobStatusFilter" (selectItem)="jobStatusFilterChange($event)"/>
        </abi-form-field>
        <abi-form-field label="Active State" cols="col-12">

            <div ngbDropdown>
                <button class="btn btn-outline-primary" id="itemStatus" ngbDropdownToggle>
                    {{ jobActiveFilters.display(jobActiveFilter) | translate }}
                </button>
                <div ngbDropdownMenu aria-labelledby="itemStatus">
                    <button
                        *ngFor="let ms of jobActiveFilters.values"
                        class="dropdown-item"
                        (click)="setStatus(ms.code)"
                    >
                        {{ ms.description | translate }}
                    </button>
                </div>
            </div>


            <!-- <input abiLookup="CodeJobStatus" abiTypeahead noBootstrap/> -->
        </abi-form-field>

        <abi-form-field label="Job Hold (Active)" cols="col-12">
            <div class="input-group">
                <input [extraLookups]="prependHoldLookups" abiLookup="CodeHoldType" abiTypeahead noBootstrap [ngModel]="jobHoldFilter" (selectItem)="jobHoldFilterChange($event)"/>
                <div class="input-group-append">
                    <button class="btn btn-primary" type="button" (click)="jobHoldFilterChange({item: {code: ''}})">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>


        </abi-form-field>

        <abi-form-field label="Job Hold (Cleared)" cols="col-12">
            <div class="input-group">
                <input abiLookup="CodeHoldType" abiTypeahead noBootstrap [ngModel]="jobHoldClearedFilter" (selectItem)="jobHoldClearedFilterChange($event)"/>
                <div class="input-group-append">
                    <button class="btn btn-primary" type="button" (click)="jobHoldClearedFilterChange({item: {code: ''}})">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </abi-form-field>
    </div>
    <div class="col-md-6 col-12">
    </div>
</div>


<div class="d-md-flex pb-2 mb-md-0 mt-2">
    <div class="d-flex flex-grow-1 mb-2 mb-md-0">

        <!-- <input abiLookup abiTypeahead="JobStatus" /> -->
        <!-- some controls on the left here -->
        <!-- <div ngbDropdown>
            <button class="btn btn-outline-primary" id="showJob" ngbDropdownToggle>
                {{ modelStatuses[modelStatus] | translate }}
            </button>
            <div ngbDropdownMenu aria-labelledby="showJob">
                <button
                    *ngFor="let ms of modelStatuses | keyvalue"
                    class="dropdown-item"
                    (click)="setStatus(ms.key)"
                >
                    {{ ms.value | translate }}
                </button>
            </div>
        </div> -->
        <a
            *ngIf="canEdit"
            class="btn btn-primary ml-2"
            [routerLink]="['../models', 'new']"
            ><i class="fas fa-plus"></i> {{ "Model.New" | translate }}</a
        >
    </div>
    <div class="d-flex table-actions">
        <abi-table-controls [table]="table" [dataTable]="dataTable" (resetFilters)="resetFilters()">
            <div class="prepend-buttons btn-group" *ngIf="showExportButton || showReplenishButton">
                <abi-export-buttons *ngIf="showExportButton" [useMatButton]="false" [disabled]="!canReplenish() || apiBusy" buttonClass="btn btn-primary" iconClass="" [table]="exportTable.bind(this, table)" [totalResults]="numberOfSelections" >
                    <ng-template #buttonLabel>
                        {{ 'Exchange.ExportLines' | translate }} ({{ selectectedCount() }})
                    </ng-template>
                </abi-export-buttons>
                <button *ngIf="showReplenishButton" [disabled]="!canReplenish() || apiBusy" (click)="onReplenish()" class="btn btn-primary"><i *ngIf="apiBusy" class="fas fa-spinner fa-pulse"></i> {{ 'Exchange.Transfer' | translate }} ({{ selectectedCount() }})</button>
            </div>
        </abi-table-controls>
    </div>
</div>

<div class="table-responsive">
    <table
        #table
        [abi-table]="pageName"
        [remoteData]="dataTable.search.bind(dataTable, true)"
        [rows]="dataList?.items"
        [columns]="columns"
        class="table-hover table-striped table-sm table-fixed"
        [canFilter]="true"
        [colsObs]="colsObs"
        [hiddenColumns]="true"
        (sorted)="onSort($event)"
        (filteredColumns)="onFilteredColumns($event)"
        (cellClickHandler)="onCellClick($event, table)">

    >
        <ng-template td="job.jobId" let-value="value">
            <a [routerLink]="['../', safeEncode(value)]">{{ value }}</a>
        </ng-template>
        <!-- <ng-template td="selected" let-value="value">
            <a [routerLink]="['../', safeEncode(value)]">{{ value }}</a>
        </ng-template> -->

        <ng-template [th]="resourceColumns" let-column>
            <span class="text-nowrap d-block text-truncate">{{ column.header | translate }} </span>
                <abi-select-resource
                    class="m-0 d-block mb-1"
                    [autoselectFirst]="false"
                    [allowClear]="false"
                    clearLabel="All"
                    [ngModel]="column.filter"
                    (ngModelChange)="table.filter(column, $event)"
                    placeholder="Select Resource..."
                    [codeOnly]="true"
                >
                <div class="input-group-append">
                    <button class="btn btn-outline-primary px-2" (click)="table.filter(column, null)" [disabled]="!column.filter"><i class="fas fa-times fa-sm"></i></button>
                </div>
            </abi-select-resource>
        </ng-template>

        <ng-template [th]="dateColumns" let-column>
            <span class="text-nowrap d-block text-truncate">{{ column.header | translate }} </span>
            <abi-date-range-filter
                [initialValue]="column.filter"
                (changeDate)="table.filter(column, $event)"
            ></abi-date-range-filter>
        </ng-template>

        <ng-template th="action" let-column let-parent="parentRow">
            <!-- <ng-container *ngIf="showRowSelect(parent.code)"> -->
                <div class="btn-group" role="group">
                    <button
                    type="button"
                    class="btn btn-sm btn-link"
                    (click)="toggleAll()"
                    >
                        <i
                        [class]="
                                allSelected()
                                ? 'far fa-check-square fa-fw fa-lg'
                                : 'far fa-square fa-fw fa-lg'
                                "
                            ></i>
                    </button>
                </div>
            <!-- </ng-container> -->
        </ng-template>
        <ng-template td="action" let-row="row" let-i="index">

            <!-- <ng-container *ngIf="showRowSelect(row.binId)"> -->

                <div class="btn-group" role="group">
                    <button
                        type="button"
                        class="btn btn-sm btn-link"
                        (click)="toggleSelected(row)"
                        [disabled]="!canSelect(row)"
                    >
                            <i
                            [class]="
                                isSelected(row)
                                    ? 'far fa-check-square fa-fw fa-lg'
                                    : 'far fa-square fa-fw fa-lg'
                                "
                            ></i>
                    </button>
                </div>
            <!-- </ng-container> -->
        </ng-template>
    </table>
</div>

<abi-pager
    [dataTable]="dataTable"
></abi-pager>
